'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var PICO_API_URL = function PICO_API_URL() {
  return process.env.PICO_API_URL;
};
var LANG_URL = function LANG_URL() {
  return 'https://lang.pico.tools';
};
var GIFTS = function GIFTS() {
  return '/gifts';
};
var GROUPS_USER = function GROUPS_USER() {
  return '/groups/user';
};
var NEWSLETTERS_SUBSCRIBE = function NEWSLETTERS_SUBSCRIBE() {
  return '/newsletters/subscribe';
};
var OAUTH_USER = function OAUTH_USER() {
  return '/oauth/user';
};
var OAUTH_USER_LOGIN = function OAUTH_USER_LOGIN() {
  return '/oauth/user/login';
};
var OAUTH_USER_TOKEN = function OAUTH_USER_TOKEN() {
  return '/oauth/user/token';
};
var OAUTH_USER_LINK = function OAUTH_USER_LINK() {
  return '/oauth/user/link';
};
var OAUTH_USER_RESET = function OAUTH_USER_RESET() {
  return '/oauth/user/reset';
};
var OAUTH_PUBLISHER = function OAUTH_PUBLISHER() {
  return '/oauth/publisher';
};
var OAUTH_PUBLISHER_LOGIN = function OAUTH_PUBLISHER_LOGIN() {
  return '/oauth/publisher/login';
};
var OAUTH_PUBLISHER_TOKEN = function OAUTH_PUBLISHER_TOKEN() {
  return '/oauth/publisher/token';
};
var OAUTH_PUBLISHER_LINK = function OAUTH_PUBLISHER_LINK() {
  return '/oauth/publisher/link';
};
var PURCHASE_PLAN = function PURCHASE_PLAN() {
  return '/purchase/plan';
};
var PURCHASE_SWITCH = function PURCHASE_SWITCH() {
  return '/purchase/switch';
};
var PURCHASE_PLAN_GROUP = function PURCHASE_PLAN_GROUP() {
  return '/purchase/plan/group';
};
var PURCHASE_PLAN_REACTIVATE = function PURCHASE_PLAN_REACTIVATE() {
  return '/purchase/plan/reactivate';
};
var PURCHASE_ARTICLE = function PURCHASE_ARTICLE() {
  return '/purchase/article';
};
var PURCHASE_ARTICLE_GUEST = function PURCHASE_ARTICLE_GUEST() {
  return '/purchase/article/guest';
};
var LOADER = function LOADER() {
  return '/loader';
};
var LOADER_GUEST = function LOADER_GUEST() {
  return '/loader/guest';
};
var LANDING_PAGE_DYNAMIC = function LANDING_PAGE_DYNAMIC(_ref) {
  var publisherName = _ref.publisherName;
  return "/landingPage/".concat(publisherName);
};
var LANDING_PAGE_SIGNUP_MODE = function LANDING_PAGE_SIGNUP_MODE(_ref2) {
  var publisherName = _ref2.publisherName;
  return "/landingPage/".concat(publisherName, "/confirm");
};
var LANDING_PAGE_GROUP = function LANDING_PAGE_GROUP(_ref3) {
  var publisherName = _ref3.publisherName,
      shortCode = _ref3.shortCode;
  return "/landingPage/".concat(publisherName, "/group/").concat(shortCode);
};
var LANDING_PAGE_STATIC = function LANDING_PAGE_STATIC(_ref4) {
  var publisherName = _ref4.publisherName,
      shortCode = _ref4.shortCode;
  return "/landingPage/".concat(publisherName, "/").concat(shortCode);
};
var PLANS_DISCOUNT = function PLANS_DISCOUNT() {
  return '/plans/discount';
};
var USERS = function USERS() {
  return '/users';
};
var USERS_EMAIL = function USERS_EMAIL() {
  return '/users/email';
};
var USERS_PAYMENT = function USERS_PAYMENT() {
  return '/users/payment';
};
var USERS_PAYMENT_DEFAULT = function USERS_PAYMENT_DEFAULT() {
  return '/users/payment/default';
};
var USERS_PASSWORD = function USERS_PASSWORD() {
  return '/users/password';
};
var USERS_REGISTER_CONFIRM = function USERS_REGISTER_CONFIRM() {
  return 'users/register/confirm';
};
var USERS_PLAN = function USERS_PLAN() {
  return '/users/plans';
};
var HUBSPOT = function HUBSPOT() {
  return '/publisher/hubspot/setup';
};
var SIGNUP = function SIGNUP() {
  return '/setup/signup';
};
var SETUP = function SETUP() {
  return '/publisher';
};
var SETUP_EMAIL_CHECK = function SETUP_EMAIL_CHECK() {
  return '/setup/email';
};
var SETUP_PASSWORD_CHECK = function SETUP_PASSWORD_CHECK() {
  return '/setup/password';
};
var SETUP_TWITTER = function SETUP_TWITTER() {
  return '/setup/twitter';
};
var SETUP_INSTAGRAM = function SETUP_INSTAGRAM() {
  return '/setup/instagram';
};
var TWITTER_API_URL = function TWITTER_API_URL() {
  return process.env.TWITTER_API_URL || 'https://api.twitter.com';
};
var TWITTER_OAUTH = function TWITTER_OAUTH() {
  return '/oauth2/token';
};
var TWITTER_USER_INFO = function TWITTER_USER_INFO(username) {
  return "/labs/2/users/by/username/".concat(username);
};
var INSTAGRAM_API_URL = function INSTAGRAM_API_URL() {
  return process.env.INSTAGRAM_API_URL;
};
var PUBLISHER_ID = function PUBLISHER_ID(_ref5) {
  var publisherUsername = _ref5.publisherUsername;
  return "/publisher/".concat(publisherUsername);
};
var PUBLISHER = function PUBLISHER() {
  return '/publisher/';
};
var ZIP_CODE = function ZIP_CODE() {
  return '/setup/zipcode';
};

exports.GIFTS = GIFTS;
exports.GROUPS_USER = GROUPS_USER;
exports.HUBSPOT = HUBSPOT;
exports.INSTAGRAM_API_URL = INSTAGRAM_API_URL;
exports.LANDING_PAGE_DYNAMIC = LANDING_PAGE_DYNAMIC;
exports.LANDING_PAGE_GROUP = LANDING_PAGE_GROUP;
exports.LANDING_PAGE_SIGNUP_MODE = LANDING_PAGE_SIGNUP_MODE;
exports.LANDING_PAGE_STATIC = LANDING_PAGE_STATIC;
exports.LANG_URL = LANG_URL;
exports.LOADER = LOADER;
exports.LOADER_GUEST = LOADER_GUEST;
exports.NEWSLETTERS_SUBSCRIBE = NEWSLETTERS_SUBSCRIBE;
exports.OAUTH_PUBLISHER = OAUTH_PUBLISHER;
exports.OAUTH_PUBLISHER_LINK = OAUTH_PUBLISHER_LINK;
exports.OAUTH_PUBLISHER_LOGIN = OAUTH_PUBLISHER_LOGIN;
exports.OAUTH_PUBLISHER_TOKEN = OAUTH_PUBLISHER_TOKEN;
exports.OAUTH_USER = OAUTH_USER;
exports.OAUTH_USER_LINK = OAUTH_USER_LINK;
exports.OAUTH_USER_LOGIN = OAUTH_USER_LOGIN;
exports.OAUTH_USER_RESET = OAUTH_USER_RESET;
exports.OAUTH_USER_TOKEN = OAUTH_USER_TOKEN;
exports.PICO_API_URL = PICO_API_URL;
exports.PLANS_DISCOUNT = PLANS_DISCOUNT;
exports.PUBLISHER = PUBLISHER;
exports.PUBLISHER_ID = PUBLISHER_ID;
exports.PURCHASE_ARTICLE = PURCHASE_ARTICLE;
exports.PURCHASE_ARTICLE_GUEST = PURCHASE_ARTICLE_GUEST;
exports.PURCHASE_PLAN = PURCHASE_PLAN;
exports.PURCHASE_PLAN_GROUP = PURCHASE_PLAN_GROUP;
exports.PURCHASE_PLAN_REACTIVATE = PURCHASE_PLAN_REACTIVATE;
exports.PURCHASE_SWITCH = PURCHASE_SWITCH;
exports.SETUP = SETUP;
exports.SETUP_EMAIL_CHECK = SETUP_EMAIL_CHECK;
exports.SETUP_INSTAGRAM = SETUP_INSTAGRAM;
exports.SETUP_PASSWORD_CHECK = SETUP_PASSWORD_CHECK;
exports.SETUP_TWITTER = SETUP_TWITTER;
exports.SIGNUP = SIGNUP;
exports.TWITTER_API_URL = TWITTER_API_URL;
exports.TWITTER_OAUTH = TWITTER_OAUTH;
exports.TWITTER_USER_INFO = TWITTER_USER_INFO;
exports.USERS = USERS;
exports.USERS_EMAIL = USERS_EMAIL;
exports.USERS_PASSWORD = USERS_PASSWORD;
exports.USERS_PAYMENT = USERS_PAYMENT;
exports.USERS_PAYMENT_DEFAULT = USERS_PAYMENT_DEFAULT;
exports.USERS_PLAN = USERS_PLAN;
exports.USERS_REGISTER_CONFIRM = USERS_REGISTER_CONFIRM;
exports.ZIP_CODE = ZIP_CODE;
